import React, { useEffect, useState } from "react";
import { Card, Col, Table } from "react-bootstrap";
import PageTitle from "../layouts/PageTitle";
import { useNavigate } from "react-router-dom";

import toast from "react-hot-toast";
import Lottie from "lottie-react";
import animationData from "../../images/loding.json";
import moment from "moment";
import Pagination from "../components/Pagination";
import {
  activeJobServicePostingData,
  flagPostingData,
} from "../../services/UserServices/UserService";
import S3Image from "../components/S3Image";
import ConfirmationDeleteAccount from "../components/Modal/ConfirmationDeleteAccount";

export default function Flag(props) {
  const navigate = useNavigate();
  const [addWorkout, setAddWorkout] = useState(false);
  const [deleteAccount, setDeleteAccount] = useState(false);
  const [loader, setLoader] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [jobId, setJobId] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [isBlocked, setIsBlocked] = useState(false);

  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="12" cy="5" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="19" r="2"></circle>
      </g>
    </svg>
  );

  async function handleTableList() {
    setLoader(true);
    try {
      const res = await flagPostingData(currentPage);
      setTableData(res?.data?.data?.reports);
      setTotalPages(res?.data?.data?.count);
      setLoader(false);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoader(false);
    }
  }

  async function handleActiveComponent(jobId, resourceType, isBlocked) {
    setLoader(true);
    try {
      const res = await activeJobServicePostingData({
        postId: jobId,
        resourceType,
        isActive: !isBlocked,
      });
      handleTableList();
      setLoader(false);
      setDeleteAccount(false);
      toast.success(" successfully");
    } catch (error) {
      toast.error(error?.response?.data?.message);
      setLoader(false);
    }
  }

  useEffect(() => {
    handleTableList();
  }, [currentPage]);

  const totalItems = totalPages;
  const total = Math.ceil(totalItems / 10);

  return (
    <div>
      <PageTitle
        activeMenu="Flag List"
        motherMenu="Flag"
        isButton={false}
        action={setAddWorkout}
      />

      <Col>
        {loader ? (
          <div>
            <Lottie
              style={{
                height: "200px",
                marginTop: "45px",
                padding: "30px",
              }}
              animationData={animationData}
            />
          </div>
        ) : (
          <Card>
            <Card.Body>
              <Table responsive>
                <thead>
                  <tr>
                    <th>
                      <strong>S.NO</strong>
                    </th>
                    <th>
                      <strong>Image</strong>
                    </th>
                    <th>
                      <strong>Name</strong>
                    </th>
                    <th>
                      <strong>Email</strong>
                    </th>
                    <th>
                      <strong>Reason</strong>
                    </th>
                    {/* <th>
                      <strong>Status</strong>
                    </th> */}
                    <th>
                      <strong>Updated on</strong>
                    </th>
                    {/* <th>
                      <strong>Action</strong>
                    </th> */}
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((tension, index) => (
                    <tr key={tension._id}>
                      <td>{index + 1 + currentPage * itemsPerPage}</td>
                      <td
                        onClick={() =>
                          navigate("/job-details", {
                            state: {
                              data: tension?.resourceId,
                              type: tension?.resourceType,
                            },
                          })
                        }
                        style={{ cursor: "pointer" }}
                      >
                        <S3Image
                          imageKey={tension?.user?.image}
                          type={"Profiles"}
                          fileType={"profile-image"}
                          style={"profile-photo"}
                        />
                      </td>
                      <td
                        onClick={() =>
                          navigate("/job-details", {
                            state: {
                              data: tension?.resourceId,
                              type: tension?.resourceType,
                            },
                          })
                        }
                        style={{ cursor: "pointer" }}
                      >
                        <span className="w-space-no">
                          {tension?.user?.name}
                        </span>
                      </td>
                      <td>
                        <span className="w-space-no">
                          {tension?.user?.email}
                        </span>
                      </td>
                      <td>
                        <span>{tension?.reason}</span>
                      </td>
                      {/* <td>
                        <span className="w-space-no">{tension?.postActive ? "Inactive" : "Active"}</span>
                      </td> */}
                      <td>
                        {" "}
                        <span className="w-space-no">
                          {moment(tension?.createdAt).format("LL")}
                        </span>
                      </td>
                      {/* <td>
                        <Dropdown>
                          <Dropdown.Toggle
                            variant="info light"
                            className="light sharp btn btn-info i-false"
                          >
                            {svg1}
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item
                              onClick={() => {
                                handleActiveComponent(
                                  tension?.resourceId,
                                  tension?.resourceType,
                                  tension?.postActive
                                );
                              }}
                            >
                              {tension?.postActive ? "Active" : "Inactive"}
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td> */}
                    </tr>
                  ))}
                </tbody>
              </Table>
              {tableData?.length === 0 && (
                <div className="justify-content-center d-flex my-5 ">
                  Sorry, Data Not Found!
                </div>
              )}
              {tableData.length !== 0 && (
                <div className="card-footer clearfix">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="dataTables_info">
                      Page {currentPage * itemsPerPage + 1} to{" "}
                      {totalItems > (currentPage + 1) * itemsPerPage
                        ? (currentPage + 1) * itemsPerPage
                        : totalItems}{" "}
                      of {totalItems} entries
                    </div>

                    <div
                      className="d-flex align-items-center"
                      style={{ gap: "10px" }}
                    >
                      <Pagination
                        pageCount={total}
                        pageValue={currentPage}
                        setPage={setCurrentPage}
                      />
                    </div>
                  </div>
                </div>
              )}
            </Card.Body>
          </Card>
        )}
      </Col>
      <ConfirmationDeleteAccount
        show={deleteAccount}
        onHide={() => setDeleteAccount(false)}
        onDelete={handleActiveComponent}
        type="job"
      />
    </div>
  );
}
